export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || 'sv_se';
export const ENABLED_LOCALES = (process.env.REACT_APP_ENABLED_LOCALES || DEFAULT_LOCALE).toLowerCase().split(',');
export const APPLICATION_LOCALE_KEY = '__APPLICATION_LOCALE_KEY__';
